/*** IMPORTS FROM imports-loader ***/
var define = false;

// src/js/components/menu.js

import { gsap } from 'gsap';

class Menu {
    constructor($menuWrapper, $menuButton, params = {}) {
        this.bindMethods();
        this.handleSubmenus();

        this.menuWrapper  = $menuWrapper;
        this.menuButton   = $menuButton;
        this.menuTimeline = this.initTimeline();
        this.params       = this.initParams(params);
    }

    bindMethods() {
        this.handleComplete = this.handleComplete.bind(this);
        this.handleReverseComplete = this.handleReverseComplete.bind(this);
    }

    initParams(params) {
        const { activeClass, reverseTimeScale } = params;
        return {
            activeClass: activeClass != null ? activeClass : 'menu-active',
            reverseTimeScale: reverseTimeScale != null ? reverseTimeScale : 1
        };
    }

    initTimeline() {
        return gsap.timeline({
            paused: true,
            onComplete: this.handleComplete,
            onReverseComplete: this.handleReverseComplete
        });
    }

    init() {
        if (this.menuWrapperExist() && this.menuButtonExist()) {
            this.handleToggleMenu();
        }
    }

    handleToggleMenu() {
        this.menuButton.on('click', () => {
            if (this.menuIsActive()) {
                this.close();
            } else {
                this.open();
            }
        });
    }

    handleComplete() {
        this.dispachEvent(this.menuWrapper, 'menu:opened');
    }

    handleReverseComplete() {
        this.dispachEvent(this.menuWrapper, 'menu:closed');
    }

    open() {
        this.menuTimeline.timeScale(1).play();
        this.dispachEvent(this.menuWrapper, 'menu:open');
    }

    close() {
        this.menuTimeline.timeScale(this.params.reverseTimeScale).reverse();
        this.dispachEvent(this.menuWrapper, 'menu:close');
    }

    menuIsActive() {
        return this.menuTimeline.totalProgress() !== 0;
    }

    menuWrapperExist() {
        return this.control(this.exist(this.menuWrapper), this.getMessage('menuWrapperExist'));
    }

    menuButtonExist() {
        return this.control(this.exist(this.menuButton), this.getMessage('menuButtonExist'));
    }

    isDefined(item) {
        return typeof item !== 'undefined';
    }

    exist($item) {
        return $item.length > 0;
    }

    control(condition, message, selector = null) {
        if (!condition) {
            console.error(message, selector || '');
        }
        return condition;
    }

    dispachEvent($element, eventName, data = null) {
        const event = $.Event(eventName);
        if (data) {
            Object.keys(data).forEach(key => {
                event[key] = data[key];
            });
        }
        $element.trigger(event);
    }

    getMessage(key) {
        const messages = {
            menuWrapperExist: 'The menu wrapper (specified as 1st parameter) does not exist',
            menuButtonExist:  'The button menu (specified as 2nd parameter) does not exist'
        };
        return `Menu: ${messages[key]}`;
    }

    handleSubmenus() {
        const $toggles = $('[data-toggle-submenu]');
        const $overlay = $('.submenu-overlay');

        $('nav .item-menu a').on('click', function (e) {
            if (this.getAttribute('href') === '#') {
                e.preventDefault();
            }
        });

        $toggles.on('click', function (e) {
            const $this = $(this);
            const isOpen = $this.hasClass('submenu-open');

            $('[data-toggle-submenu]').removeClass('submenu-open');
            $overlay.removeClass('visible');

            if (!isOpen) {
                $this.addClass('submenu-open');
                $overlay.addClass('visible');
            }
        });

        $overlay.on('click', function () {
            $('[data-toggle-submenu]').removeClass('submenu-open');
            $overlay.removeClass('visible');
        });
    }

}

export default Menu;

